import packageJSON from '../../package.json'
import { projectClient } from 'constants/project'

export const AppProject = (): JSX.Element => {
  return (
    <p className="font-light tracking-wider uppercase text-xs">
      <small>{projectClient}</small>
    </p>
  )
}
